var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTipoBarco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.6 23.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.84,9.06A80.33,80.33,0,0,0,37,8.34L34.8,6.14c-1.46-1.5-3-3.06-4.26-4.32A5.82,5.82,0,0,0,26.29,0a7.05,7.05,0,0,0-1,.07L16.55,1.32l-5.48.78-3.4.49A1.63,1.63,0,0,0,6.23,4.32,1.68,1.68,0,0,0,7.83,5.9L8.93,6,10.24,6a.61.61,0,0,1,.54.33.58.58,0,0,1-.09.61,11.52,11.52,0,0,0-.49,1.2.79.79,0,0,0,.09.76.82.82,0,0,0,.68.37.69.69,0,0,0,.2,0l.15,0A1,1,0,0,0,12,8.68c.63-1.45.65-1.53.66-1.56a2.33,2.33,0,0,0-.37-1.91,2.4,2.4,0,0,0-1.73-1l-.46,0L25.57,1.94a5.62,5.62,0,0,1,.7-.05,4,4,0,0,1,2.92,1.26l.15.14.09.11-6.22.78-.31,0a1,1,0,0,0-.83,1.06,1,1,0,0,0,1,.82h.14l1.54-.19.71-.09,5.72-.71L34.3,8.28h-.66l-2.6,0a89.19,89.19,0,0,0-20.48,2.9,11.25,11.25,0,0,0-1.29.36c-.19.06-.37.12-.51.15A63.66,63.66,0,0,0,.52,14.83.89.89,0,0,0,.05,16a1,1,0,0,0,.88.59,1,1,0,0,0,.41-.09l.53-.26c10.4-4.66,21.61-5.88,29.19-6.08l2.62,0a91.42,91.42,0,0,1,10.89.62,14.08,14.08,0,0,1-6.38,8.53,15.22,15.22,0,0,1-7.39,2.06H2.08l-.53,0a.89.89,0,0,0,0,1.78H30.8a17.17,17.17,0,0,0,8.32-2.32,16,16,0,0,0,7.46-10.61.91.91,0,0,0-.74-1.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipoBarco);
export default __webpack_public_path__ + "static/media/tipo_barco.378de7852e7dd75f5aea3e0d48547664.svg";
export { ForwardRef as ReactComponent };